import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    customScrollbarContainer: {
      height: '260px',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        height: '60px',
        borderRadius: '30px',
        backgroundColor: '#7495FF',
      },
    },
    customScrollbarContainerall: {
      height: '565px',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        height: '60px',
        borderRadius: '30px',
        backgroundColor: '#7495FF',
      },
    },
    headerContainer: {
      backgroundColor: '#5981FF',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '12px',
      margin: '20px 20px',
      padding: '17px 0px',
      height: '60%',
    },
    text: {
      fontSize: '20px !important',
      fontWeight: '600 !important',
      marginBottom: theme.spacing(2),
    },
    headerText: {
      fontSize: '20px !important',
      fontWeight: '600 !important',
    },
    subquestion: {
      padding: '12px',
      borderRadius: '12px',
      display: 'flex',
      flexDirection: 'column',
    },
    searchBox: {
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(2),
      width: '60%',
    },
    fontsubq: {
      fontSize: '16px !important',
      fontWeight: '500 !important',
      color: '#3061FF',
    },
    fontsuba: {
      fontSize: '16px !important',
      fontWeight: '400 !important',
      textAlign: 'left',
      padding: '0px 68px',
      color: '#373A45',
    },
    inputBase: {
      backgroundColor: 'white',
      borderRadius: '5px',
      padding: theme.spacing(1),
      flexGrow: 1,
    },
    cardDesign: {
      margin: '10px 0px 0px 16px',
      padding: '10px',
      borderRadius: '12px !important',
      boxShadow: 'none !important',
      height: '88%',
    },
    viewmoredesign: {
      margin: '10px 20px 0px 20px',
      padding: '10px',
      borderRadius: '12px !important',
      boxShadow: 'none !important',
    },
    RequestCard: {
      backgroundColor: '#5981FF !important',
      cursor: 'pointer',
      color: 'White !important',
      borderRadius: '12px !important',
      textAlign: 'center',
      padding: '16px',
      height: '84%',
      margin: '10px 0px',
    },
    ComplainCard: {
      backgroundColor: '#fff !important',
      cursor: 'pointer',
      color: 'Black !important',
      borderRadius: '12px !important',
      textAlign: 'center',
      padding: '16px',
      height: '83%',
      width: '87%',
      margin: '10px 0px',
    },
    RCtypo: {
      fontSize: '18px !important',
      fontWeight: '500 !important',
    },
    dilogHeader: {
      fontSize: '20px !important',
      fontWeight: '500 !important',
      marginBottom: '12px !important',
      borderBottom: '2px solid #BFCEFF',
      paddingBottom: '10px',
    },
    dilogtypo: {
      fontSize: '16px !important',
      fontWeight: '500 !important',
      marginBottom: '8px !important',
    },
    requestFlex: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    links: {
      color: '#5981FF !important',
      fontSize: '16px !important',
      fontWeight: '500 !important',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      cursor: 'pointer',
    },
    rsCard: {
      padding: '16px !important',
      margin: '10px 0px !important',
      backgroundColor: '#F6F8FB !important',
      boxShadow: 'none !important',
      borderRadius: '12px !important',
      cursor: 'pointer',
    },
    RequestMainCard: {
      backgroundColor: 'white',
      margin: '20px 0px 0px 25px',
      padding: '10px 20px 90px',
      borderRadius: '12px',
    },
    dynamicheight: {
      backgroundColor: 'white',
      margin: '20px 0px 0px 25px',
      padding: '0px 20px',
      borderRadius: '12px',
      height: '100%',
    },
    RequestMainCard1: {
      width: '100% !important',
      backgroundColor: 'white',
      margin: '20px 0px 0px 25px',
      padding: '20px 20px',
      borderRadius: '12px !important',
      boxShadow: 'none !important',
    },
    borderText: {
      fontSize: '20px',
      fontWeight: 600,
      borderBottom: '1px solid #BFCEFF',
      display: 'flex',
      padding: '10px 0px',
    },
    marginToppx: {
      marginTop: '10px !important',
      paddingBottom: '15px !important',
    },
    requestStypoh: {
      fontSize: '16px',
      fontWeight: '600 !important',
      display: 'flex',
      textAlign: 'left',
      // marginBottom: '10px !important',
    },
    requestStypod: {
      fontSize: '16px',
      fontWeight: 400,
      display: 'flex',
      textAlign: 'left',
    },
    subquestionHeader: {
      display: 'flex',
      fontSize: '24px',
      fontWeight: 500,
      marginBottom: '12px',
    },
    subHeaderQuestion: {
      fontSize: '16px',
      fontWeight: 400,
      color: '#8C8E94',
      display: 'flex',
    },
    taggedHeader: {
      display: 'flex',
      fontSize: '24px',
      fontWeight: 500,
      margin: '17px 0px',
    },
    boxRounded: {
      backgroundColor: '#EAEFFF',
      padding: '10px 12px !important',
      textAlign: 'center',
      fontSize: '16px !important',
      fontWeight: '500 !important',
      borderRadius: '16px',
      color: '#1A358C',
    },
    ProfileSettings: {
      backgroundColor: '#EAEFFF',
      padding: '24px',
      borderRadius: '16px',
    },
    ProfileTyo: {
      display: 'flex',
      fontSize: '20px !important',
      fontWeight: '500 !important',
      paddingBottom: '10px !important',
    },
    typoanswerprofile: {
      fontSize: '16px !important',
      fontWeight: '400 !important',
      color: '#373A45 !important',
      textAlign: 'left',
      paddingBottom: '15px !important',
    },
    profileButton: {
      display: 'flex !important',
      borderRadius: '12px !important',
    },
    borderGrid: {
      borderTop: '1px solid #BFCEFF',
      paddingTop: '12px',
      marginTop: '20px !important',
    },
    taggedBorder: {
      borderLeft: '1px solid #BFCEFF',
      marginLeft: '15px !important',
    },
    divprofile: {
      display: 'flex',
      flexDirection: 'column',
    },
    boxmargintop: {
      marginTop: '20px',
    },
    ulPadding: {
      padding: '0px 20px !important',
    },
    ticketCardMain: {
      width: '94%',
      backgroundColor: '#fff',
      padding: '20px !important',
      height: '100% !important',
      maxHeight: '210px !important',
      margin: '20px 35px !important',
      borderRadius: '12px !important',
      boxShadow: 'none !important',
      position: 'relative',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        height: '60px',
        borderRadius: '30px',
        backgroundColor: '#7495FF',
      },
    },
    TicketHeader: {
      fontSize: '20px !important',
      fontWeight: '600 !important',
    },
    statusTicket: {
      display: 'flex',
      fontSize: '16px !important',
      fontWeight: '500 !important',
      margin: '12px 0px !important',
    },
    cardCOntentTicket: {
      borderRadius: '10px !important',
      boxShadow: 'none !important',
      backgroundColor: '#F6F8FB !important',
      cursor: 'pointer',
    },
    ticketNumber: {
      color: '#373A45 !important',
      fontSize: '14px !important',
      fontWeight: '400 !important',
      display: 'flex',
      padding: '0px 10px !important',
      paddingTop: '10px !important',
    },
    ticketHeaderTypo: {
      padding: '0px 10px !important',
      display: 'flex',
      fontSize: '16px !important',
      fontWeight: '600 !important',
    },
    ticketDescription: {
      textAlign: 'left',
      padding: '0px 10px !important',
      color: '#373A45 !important',
      fontSize: '14px !important',
      fontWeight: '400 !important',
    },
    dateHeader: {
      fontSize: '14px !important',
      fontWeight: '500 !important',
    },
    ticketDate: {
      float: 'inline-start',
      marginLeft: '5px',
      fontSize: '14px',
      fontWeight: 600,
      color: '#373A45',
    },
    greenStatus: {
      backgroundColor: '#C1DCC3 !important',
      cursor: 'text !important',
      borderRadius: '12px !important',
      color: 'black !important',
      display: 'flex',
      padding: '4px 8px',
      width: '13%',
      paddingLeft: '10px !important',
    },
    PendingStatus: {
      backgroundColor: '#FEEBBE !important',
      cursor: 'text !important',
      borderRadius: '12px !important',
      color: 'black !important',
      display: 'flex',
      padding: '4px 10px',
      width: '13%',
    },
    resolvedStatus: {
      backgroundColor: '#FBEAEA !important',
      cursor: 'pointer !important',
      borderRadius: '12px !important',
      color: '#962121 !important',
      float: 'right',
      padding: '7px 20px !important',
      fontSize: '16px',
      fontWeight: 500,
    },
    TicketCard: {
      width: '100%',
      padding: '15px 15px',
      margin: '20px 0px 0px 24px',
      boxShadow: 'none !important',
      borderRadius: '12px !important',
    },
    ticketHeaderPreview: {
      display: 'flex',
      fontSize: '16px !important',
      fontWeight: '600 !important',
    },
    GridAlignBorder: {
      textAlign: 'left',
      borderBottom: '1px solid #BFCEFF',
      borderTop: '1px solid #BFCEFF',
      margin: '20px 0px !important',
      padding: '0px 0px 15px !important',
      width: '100% !important',
      gap: '45px',
    },
    headerCardinfo: {
      fontSize: '16px !important',
      fontWeight: '600 !important',
      marginBottom: '6px !important',
    },
    subTypoCardinfo: {
      fontSize: '16px !important',
      fontWeight: '500 !important',
      color: '#585A64 !important',
    },
    SenderTypo: {
      display: 'flex',
      fontSize: '14px !important',
      fontWeight: '400 !important',
    },
    AdminSender: {
      fontWeight: '600 !important',
      backgroundColor: '#F6F8FB !important',
    },
    Typdisplay: {
      display: 'flex',
      margin: '20px 0px !important',
      gap: '3px',
    },
    MessageBox: {
      borderRadius: '12px !important',
      padding: '15px 15px',
    },
    YouMessageBox: {
      backgroundColor: '#EAEFFF',
    },
    AdminMessageBox: {
      backgroundColor: '#F6F8FB',
    },
    headerchattypo: {
      display: 'flex',
      fontSize: '16px !important',
      fontWeight: '500 !important',
    },
    descriptionChatTypo: {
      textAlign: 'left',
      padding: '12px 0px !important',
      color: '#373A45 !important',
      fontSize: '16px !important',
      fontWeight: '400 !important',
    },
    replyicon: {
      color: '#373A45',
      fontWeight: '500 !important',
      fontSize: '16px !important',
      margin: '20px 20px !important',
      marginLeft: '80% !important',
    },
    customScrollbarContainerTicket: {
      height: '550px',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        height: '60px',
        borderRadius: '30px',
        backgroundColor: '#7495FF',
      },
    },
    chatBox: {
      borderRadius: '12px !important',
      zIndex: '999 !important',
      left: '58% !important',
      top: '40% !important',
    },
    headerContaine: {
      backgroundColor: '#3061FF',
      padding: '10px 15px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    supportTeamAvatar: {
      width: '32px',
      height: '32px',
      marginRight: theme.spacing(2),
    },
    supportTeamName: {
      color: '#FFFFFF !important',
      fontWeight: '500 !important',
      fontSize: '20px !important',
    },
    closeButton: {
      color: 'white !important',
    },
    chatMessagesContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: theme.spacing(2),
      maxHeight: '300px',
      overflowY: 'auto',
    },

    chatMessageAdmin: {
      backgroundColor: '#F6F8FB !important',
      borderRadius: '8px',
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(2),
      maxWidth: '70%',
    },

    chatMessageUser: {
      backgroundColor: '#EAEFFF !important',
      borderRadius: '8px',
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
      alignSelf: 'flex-end',
      maxWidth: '70%',
    },
    centeredPlaceholder: {
      '& .MuiInputBase-input-MuiOutlinedInput-input': {
        paddingTop: '20px !important',
      },
    },
    customSelect: {
      '& .MuiOutlinedInput-notchedOutline': {
        border: '0.5px solid #B2B3B7 !important',
        padding: '0px 12px !important',
        borderRadius: '12px !important',
      },
      '& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select': {
        padding: '10px !important',
      },
    },

    customTextArea: {
      '& .MuiInputBase-root.MuiOutlinedInput-root': {
        border: '0.5px solid #B2B3B7 !important',
        padding: '10px 12px !important',
        borderRadius: '12px !important',
        textAlign: 'center !important',
      },
    },
    customText: {
      '& .MuiInputBase-root.MuiOutlinedInput-root': {
        border: '0.5px solid #B2B3B7 !important',
        padding: '0px 12px !important',
        borderRadius: '12px !important',
        textAlign: 'center !important',
      },
      '& .MuiInputBase-input.MuiOutlinedInput-input': {
        padding: '10px !important',
      },
    },
    replyButton: {
      marginLeft: 'auto',
      marginRight: theme.spacing(2),
    },

    messageInputContainer: {
      display: 'flex',
      alignItems: 'center',
      borderTop: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(2),
    },
    dibtextflex: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #EDEEF1',
      width: '100%',
      padding: '0px 10px',
      borderRadius: '12px',
    },
    messageInput: {
      flex: 1,
      marginRight: theme.spacing(1),
    },
    notchedOutline: {
      border: 'none !important',
    },
    attachFilesIcon: {
      cursor: 'pointer',
    },
    'MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },

    noBorder: {
      border: 'none !important',
    },
  })
);

export default useStyles;
